import _ from 'lodash';
import translation from './translation.yml';
import moment from 'moment';

export default (lang) => {
  switch(lang) {
    case 'en':
      moment.lang('en');
      break;
    case 'cn':
      moment.lang('zh-cn');
      break;
    case 'hk':
    case 'tw':
      moment.lang('zh-tw');
      break;
  }
  return {
    [lang]: {
      translation: _.mapValues(translation, (obj) => obj[lang] || undefined),
    },
  };
};



/** WEBPACK FOOTER **
 ** ./src/app/i18n/translation.js
 **/